import React from "react";

/**
 * Sobre de la fila de acciones (reenviar el mail de confirmación). Antes era un
 * "mail volando" con relleno, de otra familia y en una grilla de 485: ahora
 * comparte grilla de 24, trazo de 2 y `currentColor` con el resto.
 */
export default function EmailIcon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      height={props.height}
      width={props.width}
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ ...props.style, cursor: "pointer" }}
      {...props}
    >
      <path d="M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2z" />
      <path d="M22 6l-10 7L2 6" />
    </svg>
  );
}

EmailIcon.defaultProps = {
  height: `2.2rem`,
  width: `2.2rem`,
  color: "currentColor",
};
